import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import { NewPlayer } from 'pages/NewPlayer';
import { BadmintonScene } from 'pages/match/BadmintonScene';
import { ChallengeBoard } from 'pages/ChallengeBoard';
import { ScoreBoard } from 'pages/ScoreBoard';

function App() {
  return (
    <div className="App">
        <Router>
          <Routes>
            <Route path='/' element={<NewPlayer />} />
            <Route path='/match' element={<BadmintonScene />} />
            <Route path='/challenge' element={<ChallengeBoard />} />
            <Route path='/score' element={<ScoreBoard />} />
          </Routes>
        </Router>
    </div>
  );
}

export default App;
